import { useMutation, useQueryClient } from 'react-query';

import { uploadPestUserSignature } from 'api/visitReports/putchPestUserSignature';

interface UploadSignatureParams {
  visitReportId: number;
  signatureData: string;
}

const usePutchPestUserSignature = () => {
  const queryClient = useQueryClient();

  const {
    isSuccess,
    mutate: putchPestUserSignature,
    isLoading,
    error,
  } = useMutation((params: UploadSignatureParams) => uploadPestUserSignature(params), {
    onSuccess: () => {
      queryClient.refetchQueries('visitDocs');
    },
    onError: err => {
      console.error('Error uploading signature:', err);
    },
  });

  return {
    isSuccess,
    putchPestUserSignature,
    isLoading,
    error,
  };
};

export default usePutchPestUserSignature;
